import { Link } from "react-router-dom";
import { SELLER_PRIVACY_DEFAULTS } from "../../../utils/sellerIntake/sellerIntakeConstants";
import { SellerFieldError, sellerFieldDescribedBy, sellerFieldInvalid, sellerIntakeFieldFocusHandler } from "./sellerIntakeFormFieldUtils";
import { useSellerIntakeCopy } from "../../../intl/productFormCopy.js";

/**
 * @param {{
 *   input: import('../../../utils/sellerIntake/sellerIntakeTypes').SellerSubmissionInput,
 *   onChange: (patch: Partial<import('../../../utils/sellerIntake/sellerIntakeTypes').SellerSubmissionInput>) => void,
 *   errors?: Record<string, string|null|undefined>,
 *   disabled?: boolean,
 * }} props
 */
export default function SellerConsentFields({ input, onChange, errors = {}, disabled = false }) {
  const copy = useSellerIntakeCopy();
  const consentDescribedBy = [
    sellerFieldDescribedBy("consentAccepted", errors),
    "seller-intake-consent-note",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <fieldset className="sell-car-form__section-card sell-car-form__consent" disabled={disabled}>
      <legend className="sell-car-form__section-title">{copy.consentSectionTitle}</legend>

      <label className="sell-car-form__consent-label" htmlFor="seller-intake-consent">
        <input
          id="seller-intake-consent"
          name="consentAccepted"
          type="checkbox"
          checked={Boolean(input.consentAccepted)}
          data-privacy-policy-version={SELLER_PRIVACY_DEFAULTS.privacyPolicyVersion}
          aria-invalid={sellerFieldInvalid("consentAccepted", errors)}
          aria-describedby={consentDescribedBy || undefined}
          onChange={(event) => onChange({ consentAccepted: event.target.checked })}
          onFocus={sellerIntakeFieldFocusHandler}
        />
        <span>
          {copy.consentLabel}{" "}
          <span className="sell-car-form__required" aria-hidden="true">
            *
          </span>
        </span>
      </label>

      <p id="seller-intake-consent-note" className="sell-car-form__consent-note">
        {copy.consentNote}{" "}
        <Link to={SELLER_PRIVACY_DEFAULTS.privacyPolicyHref}>{copy.privacyPolicyLink}</Link>.
      </p>

      <SellerFieldError fieldKey="consentAccepted" message={errors.consentAccepted} />
    </fieldset>
  );
}
